var map = {
	"./banner-mobile.png": "bb1a",
	"./banner-mobile2.png": "c535",
	"./banner.png": "e1f2",
	"./banner2.png": "96e0",
	"./loto-4-59-luckia-mobile.png": "a386",
	"./loto-4-59-luckia.png": "5d24",
	"./loto-4-59-mobile.png": "74cc",
	"./loto-4-59.png": "6cba",
	"./lotto-5-45-mobile.png": "d231",
	"./lotto-5-45.png": "341d",
	"./lotto-6-45-mobile.png": "43a1",
	"./lotto-6-45.png": "18d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9aee";